import { createElement, ReactNode } from 'react'
import cx from 'classnames'

import BlockContent from '@sanity/block-content-to-react'

import { SanityContentBlock } from '@data/sanity/queries/types/content'

interface BlockProps {
  node: SanityContentBlock
  children: ReactNode
}

const Block = (props: BlockProps) => {
  const { markDefs, style = 'normal' } = props.node

  const hasButton = markDefs.some(
    ({ _type, isButton }) => _type === 'link' && isButton === true
  )

  if (style.includes('preamble')) {
    return <p className="text-2xl !mb-6">{props.children}</p>
  }

  // build our mock header styles
  if (style.includes('mock')) {
    return (
      <p
        className={cx({
          'is-h1': style.includes('h1'),
          'is-h2': style.includes('h2'),
          'is-h3': style.includes('h3'),
          'is-h4': style.includes('h4'),
          'is-h5': style.includes('h5'),
          'has-btn': hasButton,
        })}
      >
        {props.children}
      </p>
    )
  }

  /// go through our remaing, true header styles
  if (/^h\d/.test(style)) {
    return createElement(
      style,
      {
        className: hasButton ? 'has-btn' : undefined,
      },
      props.children
    )
  }

  // Handle all other blocks with the default serializer
  return BlockContent.defaultSerializers.types.block(props)
}

Block.displayName = 'Block'

export default Block
